// copy to clipboard

function copyToClipboard() 
{

    var btn = document.getElementById('copy-to-clipboard');
    
    if (typeof(btn) != 'undefined' && btn != null) {

        btn.addEventListener('click', function(e) {

            var btnElement = this;

            e.preventDefault();

            btnElement.classList.add('clicked');

            var tempInput = document.createElement('input');
                tempInput.value = this.getAttribute('href');

            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            tempInput.remove();

            setTimeout(function() {

                btnElement.classList.remove('clicked');

            }, 1500);

        });

    }

}

export default function init() {

    copyToClipboard();

}